export const ajouterFacture = async (invoiceData) => {

    const token = localStorage.getItem('token'); // Get token from localStorage
    const apiUrl = process.env.REACT_APP_API_URL;

    const response = await fetch(`${apiUrl}/api/facture`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`, // Attach the token here
        },
        body: JSON.stringify(invoiceData),
    });

    if (!response.ok) {
        throw new Error('Failed to submit invoice');
    }
    return await response.json(); // Return the response body (if needed)
};

